import { Fragment, FunctionComponent, ReactNode } from 'react';

import { DescriptionListItem, DescriptionListTerm } from '@netiva/classifieds-ui';

export type ItemValue = ReactNode;

export type ItemProps = {
  label: string;
  value: ItemValue | ItemValue[];
};

// Values that render nothing must not produce a stray term or separator space.
const isBlank = (value: ItemValue) =>
  value === null || value === undefined || typeof value === 'boolean' || (typeof value === 'string' && !value.trim());

export const Item: FunctionComponent<ItemProps> = ({ label, value }) => {
  const values = (Array.isArray(value) ? value : [value]).filter((item) => !isBlank(item));

  if (!values.length) {
    return null;
  }

  return (
    <>
      <DescriptionListTerm>{label}</DescriptionListTerm>
      <DescriptionListItem>
        {values.map((item, index) => (
          <Fragment key={index}>
            {index > 0 && ' '}
            {typeof item === 'string' ? item.trim() : item}
          </Fragment>
        ))}
      </DescriptionListItem>
    </>
  );
};
